export default __webpack_public_path__ + "static/media/2F9FE166-0EB9-4518-A1EC-EE130801CE98_1_105_c.19a46276.jpeg";